import {observer} from "mobx-react-lite";
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {useEffect, useState} from "react";
import {getByContract, generateReport, deleteReport} from "../http/reportApi";
import {getContract} from "../http/contractApi";
import {LOGIN_ROUTE, REPORT_ROUTE} from "../utils/constants";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import PeriodChooser from "../components/PeriodChooser";
import {DataGrid} from "@mui/x-data-grid";
import Autocomplete from "@mui/material/Autocomplete";
import {getAll} from "../http/userApi";


const Reports = observer(()=>{
    let { contract } = useParams();
    const colLabels = {
        vat: 'Расходы',
        period: 'Период',
        singer: 'Лицензиар',

    };
    const [showForm, setShowForm] = React.useState(false);
    const [form, setForm] = React.useState({
        vat: 0,
        period: "",
        singersId: 0
    });
    const [reports, setReports] = React.useState([]);
    const [columns, setColumns] = React.useState([]);
    const [editId, setEditId] = React.useState(0);
    const [users, setUsers] = React.useState([]);
    const [contractInfo, setContractInfo] = React.useState({});
    const navigate = useNavigate();

    const deleteReportById = async (reportId) => {
        let result = [];

        if (window.confirm("Уверены, что хотите удалить элемент?")) {
            // Code to execute if the user clicks "OK"
            result = await deleteReport(reportId);
            console.log(result);
        } else {
            // Code to execute if the user clicks "Cancel"
            // console.log("Deletion cancelled.");
        }

    }
    const getData = async (contract)=>{
        let result = [];

        let cols = [];
        result = await getByContract(contract);
        delete result['contract'];
        let tableData = [];
        for (const resultKey in result) {
            const {contract, ...other} = result[resultKey];
            // console.log(contract, other);
            tableData.push({
                ...other,
                "status": other['status'] === 'ready' ? 'Финал' : 'В работе',
                ["vat"]: other.vat + " р",
            });
        }
        console.log(tableData);
        if(result.length){
            for (const resultKey in result[0]) {
                if(resultKey === 'status'){
                    cols.push({
                        field: 'status',
                        headerName: 'Статус',
                        width: 100,
                        editable: false,
                        description: 'Статус',
                        sortable: true,
                    });
                } else if (resultKey !== 'contract' && resultKey !== 'contractId' && resultKey !== 'createdAt' && resultKey !== 'updatedAt'){
                    cols.push({
                        field: resultKey,
                        headerName: Object.keys(colLabels).includes(resultKey) ? colLabels[resultKey] : resultKey,
                        width: resultKey === "id" ? 30 : 200,
                        editable: false,
                        description: resultKey,
                        sortable: true,
                    });
                }
            }
        }

        cols.push({
            field: 'action',
            headerName: 'Действия',
            sortable: false,
            width: 400,
            renderCell: (params)=>{
                return <>
                    <Button
                        variant="contained"
                        color="info"
                        onClick={(e)=>{
                        e.preventDefault();
                        console.log(params);
                        navigate(REPORT_ROUTE + "/" + params.id);
                    }}>Просмотр</Button>
                    <Button
                        style={{marginLeft: 20}}
                    variant="contained"
                    color="error"
                    onClick={async (e)=>{
                        e.preventDefault();
                        await deleteReportById(params.id);
                    }}>Удалить</Button>
                </>
            }
        });

        console.log(cols);

        setColumns(cols);

        return result;
    }

    const getContractInfo = async (contract) => {
        let result = {};
        result = await getContract(contract);
        return result;
    }

    const rowClick = async () => {

    }

    const getUsers = async () => {
        try {
            const parsed = await getAll();
            setUsers([...parsed.filter(item => (item.role === "ARTIST"))]);
            if(parsed.length){
                setForm(prevState => ({...prevState, singersId: parsed[0]}));
            }
            return [...parsed.filter(item => (item.role === "ARTIST"))];
        } catch (error) {
            // if (error.response.status === 401) {
            //     localStorage.clear();
            //     user.setIsAuth(false);
            //     return navigate(LOGIN_ROUTE);
            // }
        }
    };

    useEffect(() => {
        (async ()=>{
            await getUsers();
        })();
    }, []);

    const formChange = (e, newVal) => {
        // console.log(e.target.type, e.target.value, e.target.name, newVal);
        console.log(e);
        if(e.year){
            setForm(prevState => ({...prevState, 'period': `${e.year}/${e.quarter}`}));
        } else if(e.target.type === "checkbox") {
            setForm(prevState => ({ ...prevState, [e.target.name]: e.target.checked }));
        } else {
            setForm(prevState => ({...prevState, [e.target.name]: e.target.value}));
        }
    }

    const onSubmit = async (e)=>{
        e.preventDefault();

        console.log(form);
        let result = await generateReport({
            ...form,
            contractId: contract,
            singersId: form.singersId.id
        });

        setForm({
            vat: 0,
            period: "",
            singersId: 0
        });
        setShowForm(false);

        let data = await getData(contract);
        console.log(data);
        setReports([...data]);
    }

    useEffect(() => {
        (async ()=>{
            let data = await getData(contract);
            console.log(data);
            setReports([...data]);
        })();
    }, [contract]);

    useEffect(() => {
        (async ()=>{
            let data = await getContractInfo(contract);
            setContractInfo(data);
        })();
    }, [contract]);

    let formattedDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date()).split(" ").join(" ");
    let formattedCreateDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date()).split(" ").join(" ");
    let leftDays = 999;
    if(contractInfo?.dateExpire){
        formattedDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date(contractInfo.dateExpire)).split(" ").join(" ");
        formattedCreateDate = new Intl.DateTimeFormat('ru-Ru',{year:"numeric", month:"long",day:"2-digit"}).format(new Date(contractInfo.createdAt)).split(" ").join(" ");
        let delta = new Date(contractInfo.dateExpire) - new Date();
        console.log(Math.floor(delta/1000/60/60/24));
        leftDays = delta > 0 ? Math.floor(delta/1000/60/60/24) : 0;
    }

    let trackList = [];
    for (const key in contractInfo.tracks) {
        const item = contractInfo.tracks[key];
        trackList.push(`${item.artist} - ${item.title}`);
    }
    trackList = trackList.join("<br />");

    console.log(reports);
    const renderInfo = ()=>{
        let result = [];

        // console.log(users.length);
        if(users.length > 0){
            for (const reportsKey in reports) {
                let reportItem = reports[reportsKey];
                let singers = users.filter(item=>item.id === reportItem.singer);
                // console.log(users);
                // console.log(reportItem);
                // console.log(singers);
                if(singers && singers.length > 0) {
                    result.push({
                        ...reportItem,
                        singer: `${singers[0].name}`
                    });
                }
            }

            return result;
        }

        return reports
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="flex-end"
                width={'100%'}
                p={2}
            >
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={()=>{
                        setEditId(0);
                        setShowForm(true);
                        console.log(form);
                    }}
                >Создать отчет</Button>
            </Box>
            <Dialog
                open={showForm}
                onClose={()=>{setShowForm(false); setEditId(0);}}
                width={800}
                my={4}
                gap={4}
                p={2}
                sx={{ border: "2px solid grey" }}
            >
                <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    flexDirection="column"
                >
                    <Box
                        p={2}
                    >
                        <Typography variant="h4" gutterBottom>
                            {editId ? "Редактирование отчета" : "Создание отчета"}
                        </Typography>
                    </Box>
                    <Box
                        width={"100%"}
                        p={2}
                        display="flex"
                        alignItems="center"
                        gap={4}
                        justifyContent="space-between"
                    >
                        <TextField
                            className="login__page__item"
                            label="Tax fee"
                            name={'vat'}
                            type={"number"}
                            variant="outlined"
                            color="secondary"
                            value={form['vat']}
                            sx={{"flex": "1 1 100%"}}
                            onChange={formChange}
                        />
                    </Box>
                    <Box
                        p={2}
                        display="flex"
                        alignItems="stretch"
                        gap={4}
                        justifyContent="space-between"
                        flexDirection="column"
                    >
                        <Autocomplete
                            width={"100%"}
                            disablePortal
                            // freeSolo
                            noOptionsText={"Нет доступных лицензиаров в списке"}
                            id="combo-box-demo"
                            options={users}
                            onChange={(event, newValue) => {
                                // setValue(newValue);
                                console.log(event, newValue);
                                if(newValue){
                                    formChange({
                                        target: {
                                            value: newValue,
                                            name: "singersId"
                                        }
                                    });
                                }
                            }}
                            renderInput={(params, ref) => <TextField
                                {...params}
                                color="secondary"
                                name={"singersId"}
                                ref={ref}
                                inputProps={{
                                    ...params.inputProps, // HERE
                                    maxLength: 255
                                }}
                            />}
                            getOptionLabel={(option) => {
                                console.log(option);
                                console.log(users);
                                for (const userListKey in users) {
                                    if(users[userListKey]['id'] === option.id){
                                        return users[userListKey]['name'];
                                    }
                                }
                                return users[option] ? users[option].name : ""
                            }}
                            value={form["singersId"]}
                            isOptionEqualToValue={(option, value)=> {
                                // console.log(option);
                                // console.log(singersId);
                                // console.log(value);
                                return form["singersId"] === value
                            }}
                        />
                        {/*<TextField*/}
                        {/*    className="login__page__item"*/}
                        {/*    label="vat"*/}
                        {/*    name={'vat'}*/}
                        {/*    type={"number"}*/}
                        {/*    variant="outlined"*/}
                        {/*    color="secondary"*/}
                        {/*    value={form['vat']}*/}
                        {/*    sx={{"flex": "1 1 100%"}}*/}
                        {/*    onChange={formChange}*/}
                        {/*/>*/}
                    </Box>
                    <Box
                        width={"100%"}
                        p={2}
                        display="flex"
                        alignItems="center"
                        gap={4}
                        justifyContent="space-between"
                    >
                        <PeriodChooser
                             setPeriod={formChange}
                        />
                    </Box>
                    <Box
                        p={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={4}
                    >
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={()=>{
                                setForm({});
                                setEditId(0);
                                setShowForm(false);
                            }}
                        >
                            Отмена
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={onSubmit}
                        >
                            {editId ? "Обновить отчет" : "Добавить отчет"}

                        </Button>
                    </Box>
                </Box>
            </Dialog>
            <Box
                width={'100%'}
                p={2}
            >
                <Box
                    p={2}
                >
                    <Typography variant={'h4'}>Договор <u><b>{contractInfo.name}</b></u></Typography>
                </Box>
                <Box
                    p={2}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td valign={'top'}>Треки (версии названий):</td>
                                <td dangerouslySetInnerHTML={{__html: trackList}}></td>
                            </tr>
                            <tr>
                                <td>Создан:</td>
                                <td><b>{formattedCreateDate}</b></td>
                            </tr>
                            <tr>
                                <td>Срок заверщения:</td>
                                <td><b>{formattedDate} ({leftDays} дней)</b></td>
                            </tr>
                            {contractInfo.description ? <tr><td>Комментарий:</td><td>{contractInfo.description}</td></tr> : ""}
                        </tbody>
                    </table>

                </Box>
                <Box
                    p={2}
                >
                    <Typography variant={'h5'}>Отчеты</Typography>
                    {reports && columns && (
                        <Box sx={{ height: "100%", width: "100%" }}>
                            <DataGrid
                                rows={renderInfo()}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 100,
                                        },
                                    },
                                }}
                                pageSizeOptions={[10, 20, 50, 100]}
                                disableRowSelectionOnClick
                                onRowClick={rowClick}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </div>
    )
});

export default Reports;